import React from 'react';
import { PDFDocument } from 'pdf-lib';
import _ from 'underscore';
import { typesFiles } from '../types/uploaded-data';

const initialFile = {} as FileList;
const fileFormat: File = new File([''], '');

const handleFileChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  update: any
) => {
  e.preventDefault();
  const reader = new FileReader();
  if (e.target.files) {
    const files = e.target.files;

    reader.onloadend = () => {
      update(files);
    };
    reader.readAsDataURL(files[0]);
  }
};

const downloadFile = (data: any, name: string) => {
  window.open(URL.createObjectURL(new Blob([data], { type: typesFiles.pdf })));
};

const displayFile = (data: any, name: string) => {
  const blob = new Blob([data], { type: typesFiles.pdf });

  return new File([blob], name, { type: typesFiles.pdf });
};

const downloadExcel = (data: any, name: string) => {
  const blob = window.URL.createObjectURL(
    new Blob([data], {
      type: typesFiles.excel
    })
  );
  const link = document.createElement('a');
  link.href = blob;

  link.setAttribute('download', `${name}.xlsx`);
  document.body.appendChild(link);
  link.click();
};

const checkFilesHaveSameType = (files: FileList, type: string) =>
  files && !Array.from(files).find((file: File) => file.type !== type);

const fileToArrayBufferPromise = (file: File) =>
  new Promise(resolve => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.readAsArrayBuffer(file);
  });

const combineFiles = async (
  files: FileList,
  fileName: string,
  sortOrder?: any
) => {
  if (_.isEmpty(files) || files.length === 0) {
    return new File([''], '');
  }

  const mergedPdf = await PDFDocument.create();
  let sorted = Array.from(files);

  if (sortOrder) {
    const order = sortOrder.map((file: any) => file.text);
    sorted = Array.from(files).sort(
      (file1, file2) => order.indexOf(file1.name) - order.indexOf(file2.name)
    );
  }
  console.log(sorted);
  for (let i = 0; i < sorted.length; i++) {
    var buffer = await fileToArrayBufferPromise(sorted[i]);

    var added = await PDFDocument.load(buffer as ArrayBuffer);

    const copiedPages = await mergedPdf.copyPages(
      added,
      added.getPageIndices()
    );
    copiedPages.forEach(page => mergedPdf.addPage(page));
  }

  const mergedPdfFile = await mergedPdf.save();

  const blob = new Blob([mergedPdfFile], { type: 'application/pdf' });
  return new File([blob], `${fileName}.pdf`, { type: 'application/pdf' });
};

export {
  fileFormat,
  initialFile,
  handleFileChange,
  downloadFile,
  displayFile,
  downloadExcel,
  checkFilesHaveSameType,
  combineFiles
};
